var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "highlight_off_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.32,
    height: 137.321,
    viewBox: "0 0 137.32 137.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2177",
    "data-name": "Trac\\xE9 2177",
    d: "M0,0H137.321V137.321H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2178",
    "data-name": "Trac\\xE9 2178",
    d: "M74.036,36.33,59.217,51.149,44.4,36.33,36.33,44.4,51.149,59.217,36.33,74.036,44.4,82.1,59.217,67.285,74.036,82.1,82.1,74.036,67.285,59.217,82.1,44.4ZM59.217,2a57.217,57.217,0,1,0,57.217,57.217A57.165,57.165,0,0,0,59.217,2Zm0,102.991a45.774,45.774,0,1,1,45.774-45.774A45.834,45.834,0,0,1,59.217,104.991Z",
    transform: "translate(9.443 9.443)",
    fill: "#128ca5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.ec86ed9b.svg";
export { ForwardRef as ReactComponent };